import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[app-narrow-sidebar-logo]',
})
export class NarrowSidebarLogoDirective {
  @Input() @HostBinding('src') src?: string;
  @Input() @HostBinding('alt') alt?: string;
}
